import { t } from "@lingui/macro";
import {
  type ProformaInvoiceForNavigationQuery,
  useProformaInvoiceForNavigationQuery,
} from "@src/__generated__/graphql";
import { useNavigationPages } from "@src/components/widgets/AppSubNav/hooks";
import type { NavigationHook } from "@src/components/widgets/AppSubNav/hooks/types";

export function useProformaInvoiceNavigation(
  invoiceId?: string,
): NavigationHook<
  ProformaInvoiceForNavigationQuery["outgoingProformaInvoice"]
> {
  const { data, loading } = useProformaInvoiceForNavigationQuery({
    fetchPolicy: "cache-first",
    variables: {
      id: invoiceId ?? "",
    },
    skip: !invoiceId,
  });

  const { activePage, activeSubpage, allPages, visiblePages } =
    useNavigationPages([
      {
        title: () => t`Proforma invoices`,
        href: {
          pathname: "/invoices/proforma-invoices",
        },
        subPages: [
          {
            title: () =>
              data?.outgoingProformaInvoice?.invoice_no
                ? `${t`Proforma invoice`} #${data.outgoingProformaInvoice.invoice_no}`
                : t`Proforma invoice detail`,
            href: {
              pathname: "/invoices/proforma-invoices/detail",
              query: {
                id: invoiceId,
              },
            },
          },
          {
            title: () => t`Edit`,
            href: {
              pathname: "/invoices/proforma-invoices/edit",
              query: {
                id: invoiceId,
              },
            },
          },
          {
            title: () => t`New request for proforma invoice`,
            href: {
              pathname: "/invoices/proforma-invoices/duplicate",
              query: {
                id: invoiceId,
              },
            },
          },
        ],
      },
    ]);

  return {
    activePage,
    activeSubpage,
    allPages,
    visiblePages,
    data: data?.outgoingProformaInvoice,
    isLoading: loading,
  };
}
